import { Badge, BadgeColor } from '@givebutter/primitives/badge';
import * as Tooltip from 'components/tooltip';
import { upperFirst } from 'lodash';
import { DateTime } from 'luxon';
import { TransactionPlan } from 'types/domain';

interface RecurringPlanStatusBadgeProps {
    plan: TransactionPlan;
}
const RecurringPlanStatusBadge = (props: RecurringPlanStatusBadgeProps) => {
    const { plan } = props;
    let badgeColor: BadgeColor;
    const status = plan.status;
    const statusReadable = upperFirst(status.replace(/_/g, ' '));
    const isCancelled = status === 'cancelled';

    switch (status) {
        case 'active':
            badgeColor = 'success';
            break;
        case 'past_due_failed':
        case 'cancelled':
            badgeColor = 'error';
            break;
        case 'ready':
        case 'paused':
        case 'past_due':
        case 'imported':
        default:
            badgeColor = 'warning';
    }

    return (
        <Tooltip.Root open={isCancelled ? undefined : false}>
            <Tooltip.Trigger asChild={true}>
                <Badge color={badgeColor}>{statusReadable}</Badge>
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content className={'!p-3'} inverse={true}>
                    <div className={'flex flex-col gap-y-2'}>
                        <p className={'font-medium'}>
                            Canceled on{' '}
                            {plan.canceled_at
                                ? DateTime.fromISO(plan.canceled_at).toLocaleString(
                                      DateTime.DATE_FULL,
                                  )
                                : 'Unknown'}
                        </p>
                        <p className={'font-medium'}>
                            Reason: {plan.cancel_reason ?? 'I stopped giving for another reason.'}
                        </p>
                    </div>
                    <Tooltip.Arrow inverse={true} />
                </Tooltip.Content>
            </Tooltip.Portal>
        </Tooltip.Root>
    );
};

export { RecurringPlanStatusBadge };
